import styles from '../styles.module.scss';

type Props = {
  title: string;
};

export const DefaultLayoutHeader: React.FC<Props> = ({ title }) => {
  return (
    <header className={styles.DefaultLayout__Header}>
      <div className={styles.DefaultLayout__Header__Title}>{title}</div>
    </header>
  );
};
